<template>
  <div class="grid grid-cols-10 bg-white shadow-xl rounded-lg">
    <div
        :class="{'lg:col-span-10': style === 'small'}"
        class="col-span-10 sm:col-span-3 relative">
      <a
          :href="session.url"><img
          :alt="session.yogaType.title"
          :class="{ 'rounded-bl-lg': !session.userIsRegistered, 'sm:absolute': style !== 'small' }"
          :src="session.imageSrc"
          class="rounded-tl-lg  w-full  object-cover h-full">
      </a>
      <div class="absolute top-2 left-2 flex-col flex   py-2 gap-y-1 px-2">
        <div v-for="tag in session.tags" :key="tag.id"
             class="uppercase text-bluegray self-start py-1 px-2 rounded-md border text-sm bg-white">
          <span class="mr-2 inline-block">{{ tag.emoji }} </span> {{ tag.title }}
        </div>
      </div>
    </div>
    <div
        :class="{'lg:col-span-10': style === 'small'}"
        class="col-span-10 sm:col-span-7 px-5 py-4 relative rounded-tr-lg border-t border-black/5 border-r">
      <h3 class="text-xl font-medium text-black"><a
          :href="session.url"
          class=" flex items-center flex-wrap justify-between hover:text-teal"><span class="pr-2">{{
          session.yogaType.title
        }}</span> <span
          class="tracking-wider text-sm uppercase font-normal">Online - {{ session.minutes }} min</span></a></h3>
      <div class="flex-shrink-0 flex items-start justify-between flex-wrap pr-2">
        <div class="text-bluegray">
          <span class="block">{{ session.startTime }} — {{ session.endTime }}</span>
          <span class="block opacity-60">{{ session.startDay }}</span>
        </div>
      </div>
      <div class=" leading-5 text-bluegray mt-4 flex flex-wrap gap-2 justify-between items-center">
        <a
            :href="session.teacherSlug">
          <div class="flex gap-x-4 items-center justify-between">
            <div
                class="relative rounded-full w-12 h-12 md:w-16 md:h-16 overflow-hidden">
              <img v-if="session.teacherPhotoUrl" :src="session.teacherPhotoUrl"
                   :alt="session.teacher.fullName" class="absolute top-0 left-0 object-cover w-full h-full">
            </div>
            <span class="font-medium  hover:text-teal">{{ session.teacher.fullName }}</span>
          </div>
        </a>
        <div
            :class="{'lg:block': style === 'small'}"
            class=" text-teal sm:hidden font-medium">{{ session.priceFriendly }}</div>
        <div

            :class="{'lg:mt-4 lg:w-full' : style === 'small'}"
            class="w-full sm:mt-0 sm:w-auto mt-4  font-medium flex items-center gap-x-4 text-teal">
          <span

              :class="{'lg:hidden' : style === 'small'}"
              class="hidden sm:block">{{ session.priceFriendly }}</span>
          <div class="text-green-darker inline-block font-medium" v-if="session.userIsRegistered">
            You are booked!
          </div>
          <div v-else-if="loggedIn">
            <checkout :disabled="!session.userIsRegistered && session.notBookable" v-if="showCheckout"
                      :session="session"></checkout>
          </div>
          <div v-else>
            <a :href="'/login?returnUrl=' + session.url" class="g--button g--button--green">Login to book</a>
          </div>
        </div>
      </div>
    </div>
    <a target="_blank" v-if="session.userIsRegistered && session.videoLink" :href="session.videoLink"
       class="col-span-10  font-medium rounded-b-lg w-full g--button--green p-2 bg-green-darker text-white text-center">
      Join the class
    </a>
    <div class="col-span-10 p-2 bg-green text-center" v-else-if="session.userIsRegistered">
      The video link will be available one hour before the class starts.
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted } from 'vue';
import Checkout from './Checkout.vue';

const currentPath = ref('');

let props = defineProps({
  loggedIn: {
    type: Boolean,
    default: false
  },
  session: Object,
  style: String
});

onMounted(() => {
  console.log(props.style);
  currentPath.value = window.location.pathname;
});

const showCheckout = true;
</script>